import React, { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import _ from 'lodash';

import config from '~/config';
import { Button } from '~/components/common';
import { breakpoints, fluidRange, styled } from '~/styles';
import { useSelector } from '~/redux';


const StyledResourcesFilters = styled.ul`
  flex: 1 0 0;
    // last-in-row button's right margin compensation (important on mobile)
  ${fluidRange('marginRight', '-15px', '-20px', breakpoints.xs, breakpoints.md)}
`

interface Props {
  allFilters: any[];

}
const ResourcesFilters: React.FC<Props> = ({ allFilters }) => {
  const user = useSelector((state) => state.user);
  const resources = useSelector((state) => state.resources);

  // router (query params, history)
  const query = queryString.parse(useLocation().search);
  const history = useHistory();

  // add a filter to the query
  function addFilter(filter) {
    if (config.debug) { console.log('add filter', filter, 'to', query.filters); }

    if (filter === 'Favorites') {
      history.push({ search: '?filters=Favorites' });
      return;
    }

    if (!query.filters) {
      history.push({ search: '?filters=' + filter });
    } else {
      const newFilters = (query.filters as string).split(',');
      newFilters.push(filter);
      if (filterActive('Favorites')) {
        newFilters.splice(newFilters.indexOf('Favorites'), 1);
      }
      history.push({ search: '?filters=' + newFilters.join() });
    }

    
  }

  // remove a filter from the query
  function removeFilter(filter) {
    if (config.debug) { console.log('remove filter', filter, 'from', query.filters); }

    let newFilters = (_.clone(query.filters) as string).split(',');
    newFilters = _.remove(newFilters, function (str) {
      return str !== filter;
    });

    if (newFilters.length) {
      history.push({ search: '?filters=' + newFilters.join() });
    } else {
      history.push({ search: '' });
    }
  }
  
  const filterActive = useCallback( filter => {
    return (
      !!query.filters &&
      typeof query.filters === 'string' &&
      query.filters.split(',').indexOf(filter) > -1
    );
  }, [query]);

  // clear all query filters
  function clearFilters() {
    if (config.debug) { console.log('clear all filers'); }
    history.push({ search: '' });
    return true;
  }

  return (
      <StyledResourcesFilters>
        <li>
          <Button
            variant='primary_inverted'
            active={!query.filters}
            onClick={() => clearFilters()}
          >
            All
          </Button>
        </li>
        <li>
          <Button
            disabled={ !user }
            active={filterActive('Favorites') }
            onClick={() =>
              clearFilters() &&
              filterActive('Favorites')
                ? removeFilter('Favorites')
                : clearFilters() && addFilter('Favorites')
            }
          
            variant='primary_inverted'>
            Favorites
          </Button>
        </li>
        {allFilters.map((filter, index) => {
          return (
            <li key={index}>
              <Button
                variant={'primary_inverted'}
                active={filterActive(filter)}
                onClick={() =>
                  filterActive(filter)
                    ? removeFilter(filter)
                    : addFilter(filter)
                }
              >
                {filter === 'Training' ? 'Training' : filter + 's'}
              </Button>
            </li>
          );
        })}
      </StyledResourcesFilters>
  );
}
export default ResourcesFilters;



// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourcesFilters.tsx